// extracted by mini-css-extract-plugin
export default {"main_page":"ToyotaRavfore_main_page__wjvgt","car_image":"ToyotaRavfore_car_image__gLfqU"};